import React from 'react';

import { Divider, Typography, styled } from '@mui/material';

import SidebarNavList, { Page } from './SidebarNavList';

const Title = styled(Typography)(({ theme }) => ({
  color: theme.customSidebar.color,
  fontSize: theme.typography.caption.fontSize,
  padding: `${theme.spacing(4)} ${theme.spacing(7)} ${theme.spacing(1)}`,
  opacity: 0.4,
  textTransform: 'uppercase',
  display: 'block',
}));

const SectionDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.customSidebar.color,
  opacity: 0.2,
  margin: `${theme.spacing(3)} ${theme.spacing(4)}`,
}));

const SidebarNavSection = ({
  title,
  pages,
  collapsed = false,
  onClose,
}: {
  title: string;
  pages: Page[];
  collapsed?: boolean;
  onClose?: () => void;
}) => {
  let heading = null;
  if (title) {
    heading = collapsed
      ? <SectionDivider />
      : <Title variant="subtitle2">{title}</Title>;
  }

  return (
    <div>
      {heading}
      <SidebarNavList onClose={onClose} pages={pages} depth={0} collapsed={collapsed} />
    </div>
  );
};

export default SidebarNavSection;
